import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  title: "",
  headerIcon: null, // SVG component to be passed
  action: "",
  type: "wheel",
  headerIconProps: {},
  referralCode: "",
  // T22.731: the wheel a gated heart tap was for (null for other gates).
  wheelId: null,
};

const nonAuthenticatedModalSlice = createSlice({
  name: "nonAuthenticatedModal",
  initialState,
  reducers: {
    openNonAuthenticatedModal: (state, action) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.headerIcon = action.payload.headerIcon;
      state.action = action.payload.action;
      state.type = action.payload.type || initialState.type;
      state.headerIconProps = action.payload.headerIconProps;
      state.referralCode = action.payload.referralCode;
      state.wheelId = action.payload.wheelId ?? null;
    },
    closeNonAuthenticatedModal: (state) => {
      state.isOpen = false;
      // Optionally reset to initial values when closed
      state.title = initialState.title;
      state.headerIcon = initialState.headerIcon;
      state.action = initialState.action;
      state.type = initialState.type;
      state.headerIconProps = initialState.headerIconProps;
      state.referralCode = initialState.referralCode;
      state.wheelId = initialState.wheelId;
    },
  },
});

export const { openNonAuthenticatedModal, closeNonAuthenticatedModal } =
  nonAuthenticatedModalSlice.actions;

export default nonAuthenticatedModalSlice.reducer;
